/* ============================================================
   MOSAIK — DEMANDE DE DEVIS  (CTA des gammes Ultima + formulaire HubSpot)

   Les gammes Ultima (Industry, Ultra, XL, Invisible) ne portent aucune
   référence Shopify : « Ajouter au panier » y est masqué de longue date
   (mosaik-controller.js, sur le change de #mosaik-collection). Le visiteur
   arrivait donc au bout de sa création sans rien à faire. Ce module reprend
   cette place — la même, dans la barre d'action — par une demande de devis.
   Aero garde son panier et n'affiche PAS ce bouton : les deux conditions sont
   exactement inverses, et c'est le même écouteur qui les tient à jour.

   Au clic :
     1. le PDF du plan est fabriqué (MosaikPdf.blob() : le MÊME document que le
        bouton « Télécharger », mais rendu en mémoire au lieu d'être remis au
        navigateur) ;
     2. le formulaire HubSpot est monté dans le popup ;
     3. le PDF est déposé dans son champ « fichier », et les deux champs que le
        plan connaît déjà — la surface et les couleurs — sont renseignés. Le
        visiteur ne ressaisit que ce que nous ne savons pas.

   Le formulaire HubSpot vit dans une <iframe> SANS src, écrite par leur script :
   elle appartient donc au même document que la page et son <input type="file">
   est accessible d'ici. C'est ce qui rend le point 3 possible. Si HubSpot passait
   un jour à une iframe distante, _attach échouerait — sans bruit, et le
   formulaire resterait utilisable à la main.

   HARD RULE, comme pour les stats : rien ici ne doit casser le configurateur.
   Le PDF qui échoue, le script HubSpot bloqué par un anti-pub, un navigateur
   sans DataTransfer : chacun dégrade vers « le formulaire s'ouvre quand même ».
   ============================================================ */
window.MosaikQuote = {

  /* Le formulaire « Demande de Devis » du portail Mosaik. Changer de formulaire
     = changer ces trois valeurs, rien d'autre. */
  PORTAL_ID: '7025023',
  FORM_ID:   'ca67cf30-1020-4e01-8e0c-fd0c92108496',
  REGION:    'na1',
  EMBED_SRC: 'https://js.hsforms.net/forms/embed/v2.js',

  // La seule gamme qui se commande en ligne : elle a le panier, pas le devis.
  CART_COLLECTION: 'Polypropylene',

  /* Propriétés HubSpot que le plan renseigne à notre place. On vise le nom de
     la propriété, pas le nom du champ : le formulaire est rattaché à un ticket,
     donc HubSpot préfixe (« TICKET.hs_file_upload »), et ce préfixe suit sa
     configuration. Le sélecteur accepte les deux formes. */
  FIELD_SURFACE: 'surface_m_',
  FIELD_COLOURS: 'couleur',

  m: null, _ov: null, _note: null, _onKey: null, _embed: null, _seq: 0,

  $:function(id){ return document.getElementById(id); },
  t:function(s){ return (this.m && this.m.getText) ? this.m.getText(s) : s; },

  /* Le CTA se montre partout SAUF sur Aero. Appelé au démarrage et à chaque
     changement de gamme (mosaik-controller.js), donc juste après que
     setCollection() a écrit options.currentCollection. */
  applies:function(){
    const cur = (this.m && this.m.options) ? this.m.options.currentCollection : null;
    return !!cur && cur !== this.CART_COLLECTION;
  },
  syncVisibility:function(){
    const b = this.$('mosaik-quote-btn');
    if(b) b.style.display = this.applies() ? '' : 'none';
  },

  setup:function(mosaik){
    this.m = mosaik;
    const b = this.$('mosaik-quote-btn'), self = this;
    if(!b) return;
    b.innerText = this.t('Request a quote');
    b.addEventListener('click', () => self.open());
    this.syncVisibility();
  },

  /* ---------- le popup ---------- */

  open:function(){
    if(this._ov) return;                       // déjà ouvert : un double-clic ne le double pas
    const self = this;
    const seq  = ++this._seq;                  // fermer puis rouvrir annule le montage en cours

    if(window.MosaikStats) MosaikStats.track('quote_open');

    const ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(36,51,58,.55);z-index:10003;'
      + 'display:flex;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;'
      + 'opacity:0;transition:opacity .18s;';

    const card = document.createElement('div');
    card.style.cssText = 'position:relative;background:#fff;max-width:620px;width:100%;max-height:100%;'
      + 'box-sizing:border-box;border-radius:18px;padding:22px;overflow:auto;-webkit-overflow-scrolling:touch;'
      + 'box-shadow:0 18px 50px rgba(0,0,0,.28);font-family:Arial,Helvetica,sans-serif;'
      + 'transform:translateY(10px);transition:transform .18s;';

    const close = document.createElement('button');
    close.type = 'button';
    close.innerText = '✕';
    close.setAttribute('aria-label', this.t('Close'));
    close.style.cssText = 'position:absolute;top:14px;right:14px;width:32px;height:32px;padding:0;border:0;'
      + 'border-radius:50%;background:#f1f5f7;color:#6a7a82;font-size:15px;line-height:1;cursor:pointer;'
      + 'display:inline-flex;align-items:center;justify-content:center;z-index:2;transition:all .15s;';
    close.onmouseover = () => { close.style.background = '#e2ebef'; close.style.color = '#2c6b86'; };
    close.onmouseout  = () => { close.style.background = '#f1f5f7'; close.style.color = '#6a7a82'; };
    close.addEventListener('click', () => self.close());
    card.appendChild(close);

    // Bandeau d'état : « préparation… », puis « plan joint », puis l'échec
    // éventuel. Une seule ligne, toujours au même endroit — le formulaire monte
    // dessous sans la déplacer.
    const note = document.createElement('div');
    note.style.cssText = 'margin:0 34px 14px 0;padding:10px 14px;border-radius:12px;background:#eaf2f6;'
      + 'color:#2c6b86;font-size:.92em;line-height:1.4;font-weight:600;';
    note.innerText = this.t('Preparing your plan…');
    card.appendChild(note);

    // Cible neuve à chaque ouverture : hbspt.forms.create AJOUTE un formulaire à
    // sa cible, il ne la remplace pas. Réutiliser le même nœud empilerait un
    // second formulaire à la deuxième ouverture.
    const host = document.createElement('div');
    card.appendChild(host);

    this._note = note;

    ov.appendChild(card);
    document.body.appendChild(ov);
    ov.addEventListener('click', e => { if(e.target === ov) self.close(); });
    this._onKey = e => { if(e.key === 'Escape') self.close(); };
    document.addEventListener('keydown', this._onKey);
    requestAnimationFrame(() => { ov.style.opacity = '1'; card.style.transform = 'none'; });

    this._ov = ov;

    /* Le script HubSpot part TOUT DE SUITE : son téléchargement se recouvre avec
       la fabrication du PDF, qui est la partie lente (html2canvas). */
    const embed = this._loadEmbed();

    this._plan()
      .then(file => {
        if(seq !== self._seq) return;          // popup refermé entre-temps
        note.innerText = file ? self.t('Your plan is attached to the request.')
                              : self.t('Your plan could not be attached — you can still send the request.');
        if(!file){ note.style.background = '#fdf3e6'; note.style.color = '#8a5a1a'; }
        return embed.then(() => {
          if(seq !== self._seq) return;
          self._createForm(host, file);
        });
      })
      .catch(err => {
        if(seq !== self._seq) return;
        console.error('[mosaik] devis :', err && err.message);
        note.style.background = '#fdecec'; note.style.color = '#9a3434';
        note.innerText = self.t('The form could not be loaded. Please try again, or write to contact@mosaik-floor.fr.');
      });
  },

  close:function(){
    const ov = this._ov;
    if(!ov) return;
    this._ov = null; this._note = null;
    this._seq++;                               // ce qui est encore en vol ne touchera plus au DOM
    document.removeEventListener('keydown', this._onKey);
    ov.style.opacity = '0';
    setTimeout(() => { if(ov.parentNode) ov.parentNode.removeChild(ov); }, 180);
  },

  /* ---------- le plan en pièce jointe ----------
     MosaikPdf.blob() rend le document en mémoire : pas de téléchargement, et
     pas de copie dans R2 — ce PDF-là part par le formulaire, il n'a pas à
     gonfler le compteur `pdf_generated` qui compte les exports demandés.
     Un échec ici n'arrête pas la demande : on rend null et le formulaire
     s'ouvre sans pièce jointe. */
  _plan:function(){
    const self = this;
    if(!window.MosaikPdf || !MosaikPdf.blob) return Promise.resolve(null);
    return Promise.resolve()
      .then(() => MosaikPdf.blob())
      .then(blob => (blob ? new File([blob], self._fileName(), { type: 'application/pdf' }) : null))
      .catch(err => { console.error('[mosaik] plan PDF pour le devis :', err && err.message); return null; });
  },

  /* « plan-mosaik-ultra-8x4m.pdf » : le commercial qui ouvre la fiche HubSpot
     lit la gamme et la surface sans ouvrir le fichier. */
  _fileName:function(){
    const o = (this.m && this.m.options) || {};
    const label = (window.MosaikCollection && MosaikCollection.LABELS[o.currentCollection])
                  || o.currentCollection || 'plan';
    const dims = (o.width && o.height) ? '-' + o.width + 'x' + o.height + 'm' : '';
    return ('plan-mosaik-' + label + dims + '.pdf')
             .toLowerCase().replace(/[^a-z0-9.\-]+/g, '-');
  },

  /* ---------- HubSpot ---------- */

  // Une seule fois par page, quel que soit le nombre d'ouvertures. La promesse
  // est mémorisée : deux ouvertures rapprochées partagent le même chargement.
  _loadEmbed:function(){
    if(this._embed) return this._embed;
    const self = this;
    this._embed = new Promise((resolve, reject) => {
      if(window.hbspt && window.hbspt.forms) return resolve();
      const s = document.createElement('script');
      s.src = self.EMBED_SRC;
      s.charset = 'utf-8';
      s.async = true;
      s.onload  = () => (window.hbspt && window.hbspt.forms) ? resolve() : reject(new Error('hbspt absent'));
      s.onerror = () => reject(new Error('script HubSpot bloqué'));
      document.head.appendChild(s);
    });
    // Un échec ne doit pas être mis en cache : l'ouverture suivante réessaie.
    this._embed.catch(() => { self._embed = null; });
    return this._embed;
  },

  _createForm:function(host, file){
    const self = this;
    window.hbspt.forms.create({
      portalId: this.PORTAL_ID,
      formId:   this.FORM_ID,
      region:   this.REGION,
      target:   '#' + this._targetId(host),
      /* Le formulaire est configure, cote HubSpot, pour renvoyer vers la page de
         remerciement — ce qui, ici, ferait sortir le visiteur du configurateur et
         lui ferait perdre son plan. `inlineMessage` remonte dans le hs_context de
         l'envoi et prend le pas sur cette redirection POUR CET EMBARQUEMENT SEUL :
         la configuration HubSpot n'est pas touchee, et le formulaire continue de
         rediriger partout ailleurs (page contact...).
         Ne JAMAIS passer `redirectUrl` en meme temps : leur script refuse alors
         d'envoyer le formulaire (« You can only have one of these specified »). */
      inlineMessage:   this._inlineMessage(),
      onFormReady:     form => self._fill(form, file),
      onFormSubmitted: ()   => {
        // HubSpot remplace le formulaire par le message ci-dessus : notre
        // bandeau (« votre plan est joint ») parlerait d'un formulaire qui
        // n'est plus la. Une seule confirmation vaut mieux que deux.
        if(self._note) self._note.style.display = 'none';
        if(window.MosaikStats) MosaikStats.track('quote_submitted');
      }
    });
  },

  /* Le message qui remplace le formulaire une fois la demande partie. HubSpot
     l'injecte tel quel dans son iframe : les libelles, qui viennent de notre
     table de traduction, sont echappes avant d'y entrer. */
  _inlineMessage:function(){
    const esc = s => String(s).replace(/[&<>"]/g, c =>
      ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]));
    return '<h3>' + esc(this.t('Thank you, your request is on its way.')) + '</h3>'
         + '<p>'  + esc(this.t('We will come back to you shortly with your quote. Your plan is attached to it.')) + '</p>';
  },

  // hbspt.forms.create ne veut qu'un SÉLECTEUR, pas un nœud : la cible, créée à
  // la volée, reçoit ici son id.
  _targetId:function(host){
    if(!host.id) host.id = 'mosaik-quote-form-' + this._seq;
    return host.id;
  },

  /* Tout ce que le plan sait dire du projet, versé dans le formulaire.
     `form` est l'élément <form> (enveloppé jQuery par HubSpot), et il vit dans
     l'iframe sans src que leur script écrit — d'où le passage par son
     ownerDocument plutôt que par `document`, une fois pour les deux étapes.
     Chacune est isolée : un champ renommé côté HubSpot ne doit pas emporter
     l'autre, ni la demande elle-même. */
  _fill:function(form, file){
    let doc;
    try {
      const el = (form && form.jquery) ? form[0] : form;
      doc = (el && el.ownerDocument) || document;
    } catch(e){ return; }
    this._attachPlan(doc, file);
    this._prefill(doc);
  },

  /* Le PDF dans le champ fichier. On vise le TYPE et non le nom : le champ
     s'appelle « TICKET.hs_file_upload » (formulaire rattaché à un ticket), et ce
     préfixe suit la configuration HubSpot. */
  _attachPlan:function(doc, file){
    if(!file) return;
    try {
      const input = doc.querySelector('input[type="file"]');
      if(!input) return;                       // champ retiré du formulaire : rien à faire
      const dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
      // HubSpot ne lit le fichier qu'à l'envoi, mais l'événement remet d'aplomb
      // tout ce qui écouterait le champ (validation, affichage du nom).
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch(e){
      // Navigateur sans DataTransfer, iframe devenue distante… : le visiteur
      // joint son plan à la main, la demande part quand même.
      console.error('[mosaik] plan non joint au formulaire :', e && e.message);
    }
  },

  /* Surface et couleurs : deux champs OBLIGATOIRES que le plan connaît mieux que
     le visiteur. On écrase une éventuelle valeur pré-remplie par HubSpot depuis
     une demande précédente — ces deux-là décrivent le plan joint À CETTE
     demande, et une surface d'un autre chantier contredirait le PDF. */
  _prefill:function(doc){
    try {
      this._set(doc, this.FIELD_SURFACE, this._surface());
      this._set(doc, this.FIELD_COLOURS, this._colours());
    } catch(e){
      console.error('[mosaik] champs du devis non pré-remplis :', e && e.message);
    }
  },

  _set:function(doc, prop, value){
    if(!value) return;
    // Les deux formes du nom : nu, et préfixé par le type d'objet HubSpot.
    const el = doc.querySelector('[name="' + prop + '"], [name$=".' + prop + '"]');
    if(!el) return;
    el.value = value;
    // HubSpot relit le champ à l'envoi ; les deux événements sont là pour sa
    // validation, qui doit cesser de réclamer un champ désormais rempli.
    el.dispatchEvent(new Event('input',  { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  },

  /* La surface réellement posée, dalles comptées — et non largeur × longueur :
     le plan ne pose que des dalles entières, et le visiteur a pu en retirer
     (pilier, marche, porte). C'est le même décompte que le récapitulatif, pris
     à sa source (mosaik-recap.js), donc le PDF joint et ce champ ne peuvent pas
     se contredire. */
  _surface:function(){
    const m = this.m || {};
    const col = (m.collections || {})[(m.options || {}).currentCollection];
    const tiles = ((m._lastRecap || {}).tiles) || {};
    if(!col) return '';
    let n = 0;
    Object.keys(tiles).forEach(k => { n += (tiles[k].count || 0); });
    if(!n) return '';
    // Point décimal : la propriété est un texte aujourd'hui, mais elle reste
    // lisible comme un nombre si elle passait un jour au type numérique.
    return String(Math.round(n * col.width * col.height * 100) / 100);
  },

  /* Les couleurs posées, dans les libellés que le visiteur a vus à l'écran
     (le récapitulatif est indexé par nom traduit). Bornées : la propriété est
     un texte d'une ligne, pas un second devis. */
  _colours:function(){
    const names = Object.keys(((this.m || {})._lastRecap || {}).tiles || {});
    if(!names.length) return '';
    const s = names.join(', ');
    return s.length > 250 ? s.slice(0, 249) + '…' : s;
  }
};
